import { Pipe, PipeTransform } from '@angular/core';

import {
  deleteColonFromName,
  GET_NAME_PATTERN,
  KEYWORD_SEARCH_MENTION_PATTERN,
  USER_MENTION_PATTERN,
} from 'mojo-editor';

@Pipe({
  name: 'mojoMentionName',
})
export class MentionNamePipe implements PipeTransform {
  transform(value: string): string {
    if (!!value.match(KEYWORD_SEARCH_MENTION_PATTERN)) {
      return value.replace(value, `#${deleteColonFromName(value.match(GET_NAME_PATTERN)[0])}`);
    } else if (!!value.match(USER_MENTION_PATTERN)) {
      return value.replace(value, `@${deleteColonFromName(value.match(GET_NAME_PATTERN)[0])}`);
    } else {
      return value;
    }
  }
}
